"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _AccordionDetails = _interopRequireDefault(require("@mui/material/AccordionDetails"));
var _ExpansionPanelContext = _interopRequireDefault(require("./internal/ExpansionPanelContext"));
var _globalSpacing = require("./../globalSpacing");
var _tokens = require("../styles/tokens");
var _excluded = ["classes"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = function styles(theme) {
  var _root;
  return {
    root: (_root = {
      padding: _tokens.spacing20 + " " + _tokens.spacing40 + " " + _tokens.spacing40
    }, _root[theme.breakpoints.up('lg')] = {
      padding: _tokens.spacing30 + " " + _tokens.spacing50 + " " + _tokens.spacing50
    }, _root),
    none: {
      padding: 0
    }
  };
};

/**
 * A component that provides details for the parent ExpansionPanel
 */
var ExpansionPanelDetails = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames;
  var _useContext = (0, _react.useContext)(_ExpansionPanelContext.default),
    spacing = _useContext.spacingOptions.spacing;
  var classes = props.classes,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = {
    root: (0, _classnames.default)(classes.root, (_classNames = {}, _classNames[classes.none] = spacing === _globalSpacing.spacingVariant.NONE, _classNames))
  };
  return /*#__PURE__*/_react.default.createElement(_AccordionDetails.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});
ExpansionPanelDetails.muiName = 'AccordionDetails';
ExpansionPanelDetails.displayName = 'ExpansionPanelDetails';
ExpansionPanelDetails.propTypes = {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};

// If default props are needed, they must be set here
// ExpansionPanelDetails.defaultProps = { };
var _default = exports.default = (0, _styles.default)(styles)(ExpansionPanelDetails);